import { render, staticRenderFns } from "./Tutor.vue?vue&type=template&id=7ab5599a&"
import script from "./Tutor.vue?vue&type=script&lang=js&"
export * from "./Tutor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports